module.exports = __webpack_public_path__ + "static/media/ftg1.184cd6f4.jpg";